import React from 'react';
import { FaArrowRight } from 'react-icons/fa6';
import { FilePathText } from '../ToolCall/tools/FileTools';

interface FilePathDisplayProps {
    filePath: string;
    newFilePath?: string;
    operation?: 'create' | 'edit' | 'move' | 'delete';
    originalFilePath?: string;
}

export const FilePathDisplay: React.FC<FilePathDisplayProps> = ({
    filePath,
    newFilePath,
    operation,
    originalFilePath
}) => {
    const isMoveOperation = operation === 'move';
    const isDeleteOperation = operation === 'delete';
    const isCreateOperation = operation === 'create';

    if (isMoveOperation) {
        const oldPath = originalFilePath || '';
        const newPath = newFilePath || filePath;
        return (
            <div className="space-y-1">
                <div className="flex items-start">
                    <div className="text-red-500 dark:text-red-400">
                        <FilePathText text={oldPath} type="old" />
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="ml-2 mr-2">
                        <FaArrowRight
                            className="text-neutral-500 dark:text-neutral-400"
                            size={14}
                        />
                    </div>
                    <div className="text-green-500 dark:text-green-400">
                        <FilePathText text={newPath} type="new" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={getOperationColor(operation)}>
            <FilePathText
                text={filePath}
                type={isDeleteOperation ? "old" : isCreateOperation ? "new" : undefined}
                isDeleted={isDeleteOperation}
            />
        </div>
    );
};

const getOperationColor = (operation?: string) => {
    switch (operation) {
        case 'create': return 'text-green-500 dark:text-green-400';
        case 'delete': return 'text-red-500 dark:text-red-400';
        default: return '';
    }
};